import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGenerateVideoMutation } from '../core/queries/mutations';

/**
 * useVideoGeneration — хук для старта генерации видео.
 *
 * POST /api/video
 * Shape: { presetId, aspectRatio: '1:1'|'16:9'|'9:16', quality: 'Q_480P'|'Q_720P', referenceImageUrls? }
 * Response 202 → redirect /gallery
 *
 * Quality mapping: LQ → Q_480P, MQ → Q_720P.
 *
 * Returns: { generate, loading, error }
 *  - generate({ presetId, aspectRatio, quality, referenceImageUrls }) — async trigger
 *  - loading — bool, true while request is in flight
 *  - error — axios error | null
 */
export default function useVideoGeneration() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const generateVideoMutation = useGenerateVideoMutation();

  const QUALITY_MAP = {
    LQ: 'Q_480P',
    MQ: 'Q_720P',
  };

  const generate = async ({ presetId, aspectRatio, quality, referenceImageUrl, referenceImageUrls }) => {
    setError(null);
    try {
      await generateVideoMutation.mutateAsync({
        presetId,
        aspectRatio,
        quality: QUALITY_MAP[quality] ?? quality,
        referenceImageUrl,
        referenceImageUrls,
      });
      navigate('/gallery');
    } catch (e) {
      setError(e);
    }
  };

  return { generate, loading: generateVideoMutation.isPending, error };
}
